import { render, staticRenderFns } from "./inputnumber.vue?vue&type=template&id=0d534627"
import script from "./inputnumber.js?vue&type=script&lang=js&external"
export * from "./inputnumber.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports